import { render, staticRenderFns } from "./Results.AgreeAnalysis.ComparisonButton.vue?vue&type=template&id=6716e1d0&"
import script from "./Results.AgreeAnalysis.ComparisonButton.vue?vue&type=script&lang=js&"
export * from "./Results.AgreeAnalysis.ComparisonButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports